export const addFullYears = (date: Date, numberOfYears = 1) => {
    const dt = new Date(date);
    dt.setFullYear(dt.getFullYear() + numberOfYears);
    return dt;
};
